import { useEffect } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Products } from "@/components/site/Products";
import { HowItWorks } from "@/components/site/HowItWorks";
import { WhyBaneTech } from "@/components/site/WhyBaneTech";
import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";
import { homeSeo, useSeo } from "@/lib/seo";
import { Footer } from "@/components/site/Footer";
import { CapabilityMatrix } from "@/components/site/CapabilityMatrix";
import { FAQ } from "@/components/site/FAQ";
import { Ecosystem } from "@/components/site/Ecosystem";
import { RealTimeVsBatch } from "@/components/site/RealTimeVsBatch";

const SITE = "https://banetech.net";
const videoJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name: "See and control your enterprise ecosystem | Bane Tech Suite",
    description: "An overview of the Bane Tech suite: FireFly, Lemur Monitor, Bee Portfolio, Gaia Entity, FireAnt and Koala Flow working together across the enterprise ecosystem.",
    thumbnailUrl: `${SITE}/images/videos/ecosystem-suite.webp`,
    contentUrl: `${SITE}/videos/banetech-ecosystem-suite.mp4`,
    embedUrl: `${SITE}/#ecosystem`,
    uploadDate: "2026-10-20",
    duration: "PT57S",
    inLanguage: "en",
    publisher: { "@id": `${SITE}/#organization` },
  },
  {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name: "Real-Time vs. Legacy Batch Integration | Bane Tech",
    description: "How scheduled batch ETL compares with real-time, CDC-based integration in data freshness, source load and failure impact.",
    thumbnailUrl: `${SITE}/images/videos/realtime-vs-legacy-batch.webp`,
    contentUrl: `${SITE}/videos/banetech-realtime-vs-legacy-batch.mp4`,
    embedUrl: `${SITE}/#real-time`,
    uploadDate: "2026-10-20",
    duration: "PT40S",
    inLanguage: "en",
    publisher: { "@id": `${SITE}/#organization` },
  },
];

const Index = () => {
  useSeo(homeSeo);
  useEffect(() => {
    const scrollToHash = () => {
      const id = window.location.hash.slice(1);
      if (!id) return;
      document.getElementById(id)?.scrollIntoView();
    };
    scrollToHash();
    // The page is client-rendered, so the target section may not exist on
    // first paint; retry once the layout settles.
    const timer = window.setTimeout(scrollToHash, 100);
    const onHashChange = () => window.setTimeout(scrollToHash, 0);
    window.addEventListener("hashchange", onHashChange);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener("hashchange", onHashChange);
    };
  }, []);
  return (
    <div className="min-h-screen bg-background text-foreground">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(videoJsonLd) }} />
      <Navbar />
      <main>
        <Hero />
        <HowItWorks />
        <WhyBaneTech />
        <RealTimeVsBatch />
        <Ecosystem />
        <Products />
        <CapabilityMatrix />
        <About />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
